/* ContactPartnerLink.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AutoDismissFlag } from '@atlaskit/flag';
import FlagGroup from '@atlaskit/flag/flag-group';
import { Link, LinkButton } from '@atlassian/mpac-primitives';
import { FLAG_TYPE_ERROR } from '@atlassian/mpac-types';
import { useAtlaskitFlags } from '@atlassian/mpac-ui';
import React from 'react';
import { usePrivacyAndSecurityAnalytics } from '../../hooks';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const _ = "._11c81kw7{font:inherit}";
const linkStyle = null;
export const ContactPartnerLink = _ref => {
  let {
    url,
    ariaLabel
  } = _ref;
  const {
    flags,
    addFlag,
    dismissFlag
  } = useAtlaskitFlags();
  const {
    fireContactThePartnerEvent
  } = usePrivacyAndSecurityAnalytics();
  if (url) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx(Link, {
        href: url,
        "aria-label": ariaLabel,
        size: "medium",
        target: "_blank",
        rel: "external noopener noreferrer",
        onClick: () => fireContactThePartnerEvent(),
        className: ax(["_11c81kw7"]),
        children: "contact the partner"
      })]
    });
  }
  const handleLinkButtonClick = () => {
    fireContactThePartnerEvent();
    addFlag({
      id: Date.now().toString(),
      type: FLAG_TYPE_ERROR,
      title: 'Could not perform task',
      description: '',
      isAutoDismiss: true
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FlagGroup, {
      onDismissed: dismissFlag,
      children: flags.map(flag => /*#__PURE__*/_jsx(AutoDismissFlag, _objectSpread({}, flag), flag.id))
    }), /*#__PURE__*/_jsx(LinkButton, {
      onClick: handleLinkButtonClick,
      children: "contact the partner"
    })]
  });
};